import { createRoot } from "react-dom/client";
import { BrowserRouter as Router } from "react-router-dom";
import App from "./App";

import "./index.css";
import "antd/dist/reset.css";

const root = createRoot(document.getElementById("root"));

root.render(
  <Router basename="/">
    <App />
  </Router>
);
